import { locales } from '../constants/locales'

const { location } = window
export const isHomePage = (url: string): boolean => {
  const pathname = new URL(url).pathname
  const localizedHomePagePattern = /^\/([a-z]{2}(-[a-z]{2})?)\/[a-z]{2}\/?$/
  const isHome = localizedHomePagePattern.test(pathname)
  return isHome
}

export const getURLWithoutQuery = (): string => {
  // Regex - Replace trailing slash
  const urlWithoutQuery = `${location.protocol}//${location.host}${location.pathname}`.replace(
    /\/+$/,
    '',
  )

  if (isHomePage(location.href)) {
    return `${urlWithoutQuery}/`
  }
  return `${urlWithoutQuery}`
}

export const toCamelCaseFromSnakeCase = (query: string) => {
  return query
    .toLowerCase()
    .split('_')
    .map((word, index) => {
      if (index === 0) {
        return word
      }
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join('')
}
